export const noSkipStepOption = {
  labels: {
    buttonSkip: 'Stop tutorial',
    buttonPrevious: 'Previous',
    buttonNext: 'Next',
    buttonStop: 'Finish'
  }
}
